import { TableHead, TableHeader, TableRow } from "@/components/ui/table";
export const QRCodesTableHeader = () => {
  return <TableHeader>
      <TableRow>
        <TableHead className="w-20 min-w-20">Nyckel</TableHead>
        <TableHead className="w-20 min-w-20">Skapad</TableHead>
        <TableHead className="w-28 min-w-28">Telefonnummer</TableHead>
        <TableHead className="w-20 min-w-20">Grupp</TableHead>
        <TableHead className="w-12 min-w-12 text-center">Svar 1</TableHead>
        <TableHead className="w-12 min-w-12 text-center">Svar 2</TableHead>
        <TableHead className="w-12 min-w-12 text-center">Svar 3</TableHead>
        <TableHead className="w-20 min-w-20">Åtgärder</TableHead>
      </TableRow>
    </TableHeader>;
};